const paymentMethodMap = {
  mc: 'Mastercard',
  visa: 'Visa',
  amex: 'Amex'
}

export const mapPaymentMethod = (method: string) => {
  return paymentMethodMap[method] || ''
}
